import "./BookNow.module.css";
import Header from "@/reusable_sections/Header";
import ContactInfo from "./sections/ContactInfo";
import Footer from "@/reusable_sections/Footer";
export default function BookNowPage() {
  return <div>
      <Header />
      <ContactInfo />
      <Footer />
    </div>;
}